import clsx from "clsx";
import type React from "react";
import styles from "./styles.module.scss";

export default function Skeleton({
  className,
  ...props
}: Omit<React.ComponentPropsWithoutRef<"span">, "children">) {
  return <span className={clsx(styles._onetouchai_skeleton, className)} {...props} />;
}
